
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(80(22|4)|3(310|528|80)|2197|4421|4739|5805|5909|6991)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
